const BadgeController = require('./badge-controller');

module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'ctrl',
        controller: BadgeController,
        scope: {
            content: '@',
            size: '@?',
            kind: '@'
        },
        bindToController: true,
        template: require('./badge-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/badge-directive.js
 **/